<!-- 添加计量单位 -->
<template>
  <div>
    <setDialog
      dialogTitle="添加计量单位"
      :centerDialogVisible="setVisible"
      @resetPopupData="setUpdateVisible"
      @submitPopupData="setSubmitPopupData"
      :popupWidth="'420px'"
      :closeModel="false"
    >
      <el-form :model="setForm" :rules="rules" ref="setForm">
        <el-form-item label="" :label-width="formLabelWidth" prop="unitName">
          <el-input
            v-model="setForm.unitName"
            autocomplete="off"
            placeholder="输入您想要添加的计量单位"
          ></el-input>
        </el-form-item>
        <span class="txt">注：计量单位的字符不超过10个字符，当商品被审核通过时，您的计量单位才会生效</span>
      </el-form>
    </setDialog>
  </div>
</template>

<script>
import setDialog from "@/components/common/epecDialog";
export default {
  data() {
    return {
      setVisible: true,
      setForm: {
        unitId:null,
        unitName: null,
      },
      formLabelWidth: "0px",
      rules: {
           unitName: [
            { required: true, message: '输入您想要添加的计量单位', trigger: 'blur' },
            { min: 1, max: 10, message: '计量单位的字符不超过10个字符', trigger: 'blur' }
          ],
      },
    };
  },

  components: { setDialog },

  computed: {},

  created() {},
  methods: {
    setUpdateVisible() {
          this.$emit('setUnitUpdateVisible',2)
    },
    setSubmitPopupData(){
        this.$refs['setForm'].validate((valid) => {
          if (valid) {
             this.$emit('setUnitSubmitPopupData',this.setForm);
          } else {
            console.log('error submit!!');
            return false;
          }
        });
     }
  },
};
</script>
<style lang='scss' scoped>
.txt{
    font-size: 12px;
    color: #999;
}
</style>